const INBOUND_HISTORY_ID_PATTERN = /^i\d+$/i;
const OUTBOUND_HISTORY_ID_PATTERN = /^o\d+$/i;
const FINANCE_EMAIL_HISTORY_ID_PATTERN = /^[oi]\d+$/i;

export const isInboundFinanceEmailHistoryId = (value: unknown): value is string =>
  typeof value === 'string' && INBOUND_HISTORY_ID_PATTERN.test(value.trim());

export const isOutboundFinanceEmailHistoryId = (value: unknown): value is string =>
  typeof value === 'string' && OUTBOUND_HISTORY_ID_PATTERN.test(value.trim());

export const isFinanceEmailHistoryId = (value: unknown): value is string =>
  typeof value === 'string' && FINANCE_EMAIL_HISTORY_ID_PATTERN.test(value.trim());
